/* globals localStorage */

import "normalize.css";
import "@lottiefiles/lottie-player";
import Vue from "vue";
import VueShortkey from "vue-shortkey";
import App from "./App";
import router from "./router";
import axios from "axios";
import store from "./store";
import VModal from "vue-js-modal";
import Multiselect from "vue-multiselect";
import storage from "./store/storage";
import { getEnv } from "./store/envs";

Vue.component("multiselect", Multiselect);

axios.defaults.baseURL = getEnv().operatorUrl;
Vue.config.productionTip = false;
Vue.use(VModal);
Vue.use(VueShortkey);

const token = storage.getItem("token");

if (token) {
  axios.defaults.headers.common.Authorization = `Bearer ${token}`;
}

/* eslint-disable no-new */
window.vm = new Vue({
  el: "#app",
  router,
  store,
  components: { App },
  template: "<App/>",
  data: {
    sharedState: store.state,
  },
});
